export const BANNER_HEIGHT = 40;

export const DESKTOP_APP_BAR_HEIGHT = 61;

export const MOBILE_APP_BAR_HEIGHT = 52;

/** Native scrollbar width; used in layout calculations beside scrollable panes. */
export const SCROLLBAR_SIZE = 10;

export const DRAWER_WIDTH = 200;

export const SIDEBAR_MIN_PX = 260;
export const SIDEBAR_DEFAULT_PX = 300;
export const SIDEBAR_MAX_PX = 420;

// Behind the studio-sidebar flag the sidebar cannot shrink below this narrower
// width, matching Figma and keeping the Brand page asset dimensions on a single
// line. Non-studio users keep SIDEBAR_MIN_PX.
export const STUDIO_SIDEBAR_DEFAULT_PX = 240;

export const getSidebarMinPx = (enableStudioSidebar: boolean): number =>
  enableStudioSidebar ? STUDIO_SIDEBAR_DEFAULT_PX : SIDEBAR_MIN_PX;

// The studio default is pinned to the legacy width so enabling the studio flags
// on classic workspaces doesn't produce sidebar visual regressions. The flag arg
// stays so the studio width can be restored without touching call sites.
export const getSidebarDefaultPx = (_enableStudioSidebar: boolean): number =>
  SIDEBAR_DEFAULT_PX;

// Fixed width of the company column in the legacy drawer, and its default/min
// width in the resizable shell where users can widen it for long names.
export const COMPANY_SWITCHER_WIDTH = 80;
export const COMPANY_SWITCHER_MAX_PX = 200;
// 1396 = 1080 (content max width) + 280 (legacy drawer total) + 36 (left and right padding)
export const SETTINGS_PAGE_MAX_WIDTH = 1396;
export enum AppViewMode {
  CLIENT = 'client',
  INTERNAL = 'internal',
}

export const TAILWIND_BREAKPOINT_WIDTHS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
};

// Fixed-length stand-in for a stored secret: the real value is write-only, so
// the mask must not leak its length.
export const MASKED_CREDENTIAL = '••••••••••';
